import { Icon, Text, HStack, Stack, VStack } from '@genial/components';
import { Pressable } from 'native-base';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import { useClubsAssetContext } from '../../../../../contexts/products/Clubs';
import { LateralBar } from '../../../components/LateralBar';
import { clubsTableHead } from '../constants';
import { ListLoadingItemTablet } from '../ListLoadingItem/tablet';

import { ClubsItemTypes } from '.';

export const ClubsItemTablet: React.FC<ClubsItemTypes.Props> = ({ offer }) => {
  const { setModalOpen, setOfferSelected } = useClubsAssetContext();
  const { infoGetter, selectedTab, accountId } = useGlobalAssetContext();

  const { Button, isSelected, forceLoading } = infoGetter('clubs', offer, 'clubId');

  const onOpenDetailsModal = () => {
    setModalOpen(true);
    setOfferSelected({ ...offer, accountId: accountId || 0 });
  };

  const bottomInfos = [
    {
      label: clubsTableHead[1].title,
      value: <Text color="neutral.dark">{offer.managerNameNormalized}</Text>,
      maxW: '24%',
    },
    {
      label: clubsTableHead[4].title,
      value: <Text color="neutral.dark">{offer.cutoffTimeNormalized}</Text>,
      maxW: '24%',
    },
    {
      label: clubsTableHead[3].title,
      value: <Text color="neutral.dark">{offer.minimumApplicationNormalized}</Text>,
      maxW: '24%',
    },
  ];

  if (forceLoading) {
    return <ListLoadingItemTablet />;
  }

  return (
    <TableContent direction="row" space={0} p={0} px="inline.xxxs" isHighlighted={isSelected}>
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius="sm"
        borderBottomLeftRadius="sm"
      />
      <VStack padding="inset.sm" space="stack.xxxs" w="full">
        <HStack space="inline.quarck" alignItems="center">
          <Pressable onPress={onOpenDetailsModal}>
            <Icon name="Info" size="xs" />
          </Pressable>
          <Text color="neutral.dark">{offer.clubNameNormalized}</Text>
        </HStack>
        <HStack justifyContent="space-between">
          {bottomInfos.map(({ label, value, maxW }) => (
            <VStack maxW={maxW} space="stack.quarck" key={label}>
              <Text color="neutral.black" variant="semibold">
                {label}
              </Text>
              {value}
            </VStack>
          ))}
          <Stack alignSelf="flex-end" maxW={'24%'}>
            <Button
              id={selectedTab.typeGetterId}
              offer={offer}
              productContextConstant={selectedTab}
            />
          </Stack>
        </HStack>
      </VStack>
    </TableContent>
  );
};
